//#region src/reader/Plane.ts
var e = class {
	constructor(e, t) {
		this.rooms = [], this.labels = [], this.rooms = e, this.labels = t, this.bounds = this.createBounds();
	}
	getRooms() {
		return this.rooms;
	}
	getLabels() {
		return this.labels;
	}
	getBounds() {
		return this.bounds;
	}
	createBounds() {
		let e = this.rooms.reduce((e, t) => ({
			minX: Math.min(e.minX, t.x),
			maxX: Math.max(e.maxX, t.x),
			minY: Math.min(e.minY, t.y),
			maxY: Math.max(e.maxY, t.y)
		}), {
			minX: Infinity,
			maxX: -Infinity,
			minY: Infinity,
			maxY: -Infinity
		});
		for (let t of this.labels) {
			let n = t.X, r = -t.Y;
			e.minX = Math.min(e.minX, n), e.maxX = Math.max(e.maxX, n + t.Width), e.minY = Math.min(e.minY, r), e.maxY = Math.max(e.maxY, r + t.Height);
		}
		return e;
	}
}, t = {
	north: "south",
	south: "north",
	east: "west",
	west: "east",
	northeast: "southwest",
	southwest: "northeast",
	northwest: "southeast",
	southeast: "northwest",
	up: "down",
	down: "up",
	in: "out",
	out: "in"
};
function n(e) {
	let n = /* @__PURE__ */ new Map();
	e.forEach((e) => {
		Object.entries(e.exits).forEach(([t, r]) => {
			if (e.id === r) return;
			let i = `${Math.min(e.id, r)}-${Math.max(e.id, r)}`;
			n.has(i) || n.set(i, []), n.get(i).push({
				origin: e.id,
				target: r,
				z: e.z,
				dir: t
			});
		});
	});
	let r = /* @__PURE__ */ new Map();
	for (let [e, i] of n) {
		let [n, a] = e.split("-"), o = parseInt(n), s = parseInt(a), c = i.filter((e) => e.origin === o), l = i.filter((e) => e.origin === s), u = /* @__PURE__ */ new Set();
		for (let n of c) {
			let i = -1;
			for (let e = 0; e < l.length; e++) if (!u.has(e) && l[e].dir === t[n.dir]) {
				i = e;
				break;
			}
			if (i !== -1) {
				u.add(i);
				let t = l[i];
				r.set(`${e}-${n.dir}`, {
					a: o,
					b: s,
					aDir: n.dir,
					bDir: t.dir,
					zIndex: [n.z, t.z]
				});
			} else r.set(`${e}-a:${n.dir}`, {
				a: o,
				b: s,
				aDir: n.dir,
				zIndex: [n.z]
			});
		}
		for (let t = 0; t < l.length; t++) if (!u.has(t)) {
			let n = l[t];
			r.set(`${e}-b:${n.dir}`, {
				a: o,
				b: s,
				bDir: n.dir,
				zIndex: [n.z]
			});
		}
	}
	return r;
}
var r = class {
	constructor(e) {
		this.planes = {}, this.exits = /* @__PURE__ */ new Map(), this.version = 0, this.area = e, this.planes = this.createPlanes(), this.createExits();
	}
	getAreaName() {
		return this.area.areaName;
	}
	getAreaId() {
		return parseInt(this.area.areaId);
	}
	getVersion() {
		return this.version;
	}
	markDirty() {
		this.version++;
	}
	getPlane(e) {
		return this.planes[e];
	}
	getPlanes() {
		return Object.values(this.planes);
	}
	getZLevels() {
		return Object.keys(this.planes).map(Number).sort((e, t) => e - t);
	}
	getRooms() {
		return this.area.rooms;
	}
	getFullBounds() {
		return this.getPlanes().reduce((e, t) => {
			let n = t.getBounds();
			return {
				minX: Math.min(e.minX, n.minX),
				maxX: Math.max(e.maxX, n.maxX),
				minY: Math.min(e.minY, n.minY),
				maxY: Math.max(e.maxY, n.maxY)
			};
		}, {
			minX: Infinity,
			maxX: -Infinity,
			minY: Infinity,
			maxY: -Infinity
		});
	}
	getLinkExits(e) {
		return Array.from(this.exits.values()).filter((t) => t.zIndex.includes(e));
	}
	createPlanes() {
		let t = this.area.rooms.reduce((e, t) => (e[t.z] || (e[t.z] = []), e[t.z].push(t), e), {});
		return Object.entries(t).reduce((t, [n, r]) => (t[+n] = new e(r, this.area.labels.filter((e) => e.Z === +n)), t), {});
	}
	createExits() {
		this.exits = n(this.area.rooms);
	}
};
//#endregion
export { n, e as r, r as t };

//# sourceMappingURL=Area-MLM4Xe0E.js.map